async function sha256(text: string) {
    const encoder = new TextEncoder();
    const data = encoder.encode(text);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

function checkPassword(password: string) {
    var strength = 0;
    if (password.match(/[a-z]+/)) {
        strength += 1;
    }
    if (password.match(/[A-Z]+/)) {
        strength += 1;
    }
    if (password.match(/[0-9]+/)) {
        strength += 1;
    }
    if (password.match(/[$@#&!]+/)) {
        strength += 1;
    }
    if(password.length < 6) {
        return "Your password must be at least 6 characters long";
    }
    if(password.length > 16) {
        return "Your password can be maximum 16 characters long";
    }
    if(strength >= 3) {
        return "";
    }
    return "Password not secure enough. Ttry to use uppercase, lowercase, numbers and special characters";
}

export {sha256, checkPassword}